(function () {
  function isPreorder(product) {
    if (!product) return false;
    const tags = (product.tags || []).map(t => t.toLowerCase());
    const tagged = tags.includes('pre-order') || tags.includes('preorder') || tags.includes('pre order');
    const eta =
      product?.metafields?.products?.ETA ||
      product?.metafields?.products?.eta ||
      product?.metafields?.ETA ||
      product?.metafields?.eta;
    return Boolean(tagged || (eta && String(eta).trim().length));
  }

  function ensureBadge(wrapper, badgeSrc) {
    if (!wrapper || !badgeSrc) return;
    if (wrapper.querySelector('.preorder-badge')) return; // already added
    const anchor = wrapper.querySelector('[data-preorder-anchor]') || wrapper;
    const img = document.createElement('img');
    img.src = badgeSrc;
    img.alt = 'Pre-Order';
    img.className = 'preorder-badge';
    anchor.appendChild(img);
  }

  function initOnce() {
    const cfg = window.preorderBadgeConfig || {};
    const badgeSrc = cfg.badgeSrc;
    // each wrapper that includes the snippet has a product JSON tag
    document.querySelectorAll('script[data-product-json]').forEach(jsonEl => {
      let product;
      try { product = JSON.parse(jsonEl.textContent || '{}'); } catch (e) {}
      if (!isPreorder(product)) return;

      // media gallery wrapper is the closest custom element
      const wrapper =
        jsonEl.closest('media-gallery') ||
        jsonEl.closest('[data-product-card]') ||
        jsonEl.parentElement;
      ensureBadge(wrapper, badgeSrc);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOnce);
  } else {
    initOnce();
  }
})();
